import { resolveProductDetailFaceWidthFit } from './fit';
import type {
  FaceMeasurementMode,
  FaceMeasurementRecord,
  FaceWidthMeasurementEntrySource,
  PdMeasurementEntrySource,
} from './types';

export const MEASUREMENT_TRACKING_EVENT = {
  pageView: 'MeasurePage_View',
  buttonClick: 'MeasurePageBtn_Click',
  interactionClick: 'MeasurePageInteraction_Click',
} as const;

export const MEASUREMENT_TRACKING_STEP = {
  method: '测量方式选择页',
  preparation: '前置准备页',
  example: '示例页',
  permission: '摄像头授权页',
  camera: '实时测量页',
  result: '测量结果页',
} as const;

type MeasurementTrackingSource = FaceWidthMeasurementEntrySource | PdMeasurementEntrySource;

export interface MeasurementTrackingContext {
  kind: 'face-width' | 'pd';
  source: MeasurementTrackingSource;
  mode: FaceMeasurementMode;
  step: (typeof MEASUREMENT_TRACKING_STEP)[keyof typeof MEASUREMENT_TRACKING_STEP];
}

const MEASUREMENT_TYPE_BY_KIND = {
  'face-width': '脸宽测量',
  pd: 'PD测量',
} as const satisfies Record<MeasurementTrackingContext['kind'], string>;

const MEASUREMENT_METHOD_BY_MODE = {
  card: '信用卡标定',
  'pd-input': 'PD标定',
} as const satisfies Record<FaceMeasurementMode, string>;

const ENTRANCE_SCENE_BY_SOURCE = {
  'goods-list-filter': '商品列表页',
  'goods-detail-size': '商品详情页',
  'goods-detail-size-chart': '商品详情页',
  'lens-prescription-pd': '处方输入页',
} as const satisfies Record<MeasurementTrackingSource, string>;

export function buildMeasurementTrackingProperties(context: MeasurementTrackingContext) {
  return {
    measure_type: MEASUREMENT_TYPE_BY_KIND[context.kind],
    measure_step: context.step,
    measure_method: MEASUREMENT_METHOD_BY_MODE[context.mode],
    entrance_measure_scene: ENTRANCE_SCENE_BY_SOURCE[context.source],
  };
}

export function resolveMeasurementInteractionReview(feedback: 'like' | 'dislike' | undefined) {
  if (feedback === 'like') return '好评';
  if (feedback === 'dislike') return '差评';
  return '未打分';
}

export function resolveProductDetailRecommendFrameSizeTrackingValue(
  measurement: FaceMeasurementRecord | null,
  productSize: string | null | undefined,
) {
  if (!measurement) return '无';

  const fitStatus = resolveProductDetailFaceWidthFit(
    productSize,
    measurement.recommendedFrameSizes,
  );
  if (fitStatus === null) return '无';
  return fitStatus === 'fits' ? '适合' : '不适合';
}

export function buildProductDetailMeasurementTrackingProperties({
  isUk,
  isWap,
  measurement,
  productSize,
}: {
  isUk: boolean;
  isWap: boolean;
  measurement: FaceMeasurementRecord | null;
  productSize: string | null | undefined;
}) {
  if (!isUk || !isWap) return {};

  return {
    recommend_frame_size: resolveProductDetailRecommendFrameSizeTrackingValue(
      measurement,
      productSize,
    ),
  };
}
